import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "row"];

  filter() {
    const query = this.inputTarget.value.toLowerCase();
    this.rowTargets.forEach((row) => {
      const name = row.dataset.accountName.toLowerCase();
      row.style.display = name.includes(query) ? "" : "none";
    });
  }
}
